import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner({className}) {
  return (
    <div
      className={`lds-container h-36 w-full flex justify-center items-center ${className}`}
    >
      <div className='lds-default'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <i className='fa-solid fa-train fa-2x'></i>
      </div>
    </div>
  );
}

export default LoadingSpinner;
